// 页面 read time 统计参数跨路由传递
const key = '_readTimeParams_v1.0';

const ss = window.sessionStorage;

const assertIsSessionStorageNotExist = () => {
    return !ss;
};

const get = () => {
    if (assertIsSessionStorageNotExist()) {
        return null;
    }

    let data = ss.getItem(key);
    remove();

    if (!data) {
        return null;
    }

    try {
        data = JSON.parse(data);
    } catch (e) {
        data = null;
    }

    return data;
};

const set = params => {
    if (assertIsSessionStorageNotExist()) {
        return;
    }

    ss.setItem(key, JSON.stringify(params));
};

const update = params => {
    const existedParams = get();
    if (existedParams && typeof existedParams === 'object') {
        set({
            ...existedParams,
            ...params,
        });

        return;
    }

    set(params);
};

const remove = () => {
    ss.removeItem(key);
};

const ReadTimeParamsPass = {
    get,
    set,
    update,
    remove,
};

export default ReadTimeParamsPass;
